/*
 * CARVERHAUS: open Shopify Inbox live chat from any link.
 *
 * A link opens the chat when it carries [data-ch-open-chat], or when its href ends
 * in "#chat" (so menu items and buttons set in the theme editor can use it too).
 * Shopify Inbox renders <shopify-chat>, whose show() opens the chat window; older
 * Inbox versions render #ShopifyChat with a toggle button in its shadow root.
 * If neither is on the page (app embed off, or not loaded yet), the link is
 * followed as normal, so it always leads somewhere.
 */
if (!window.chChat) {
  window.chChat = {
    open() {
      const chat = document.querySelector('shopify-chat');
      if (chat && typeof chat.show === 'function') {
        chat.show();
        return true;
      }
      const legacy = document.querySelector('#ShopifyChat, inbox-online-store-chat');
      const toggle = legacy?.shadowRoot?.querySelector('button.chat-toggle, button[aria-label*="chat" i]');
      if (toggle) {
        /** @type {HTMLButtonElement} */ (toggle).click();
        return true;
      }
      return false;
    },
  };

  document.addEventListener('click', (event) => {
    const link = /** @type {HTMLElement} */ (event.target)?.closest?.('a[data-ch-open-chat], a[href$="#chat"]');
    if (!link) return;
    if (window.chChat.open()) {
      event.preventDefault();
      return;
    }
    /* No chat on the page: a bare "#chat" link has nowhere to go, so leave it be;
       a real URL is followed normally. */
    if (link.getAttribute('href') === '#chat') event.preventDefault();
  });
}
